var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelegram = function SvgIconTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M20.71 3.655s1.943-.758 1.78 1.082c-.053.757-.539 3.409-.917 6.276l-1.295 8.495s-.108 1.245-1.08 1.461c-.97.216-2.427-.758-2.697-.974-.216-.163-4.047-2.597-5.396-3.788-.378-.325-.81-.974.054-1.731l5.665-5.411c.648-.649 1.295-2.164-1.403-.324l-7.555 5.14s-.863.541-2.482.054l-3.508-1.083s-1.295-.811.918-1.623C8.19 8.688 14.828 6.09 20.709 3.656z"
  })));
};
export default SvgIconTelegram;